// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"59a242c1","196":"8e2f98a4","224":"065b9f3f","661":"19ba435f","747":"eb81890b"}[chunkId] + ".chunk.js";
};